import Layout from "../Layouts/layout";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import useAlertUtils from "../../../utils/common.utils";
import { fetchData } from "../../../services/apiService";
import axiosInstance from "../../../services/interceptor";
import "./ScheduledMeetings.scss";

function ScheduledMeetings() {
  const [bookingsData, setBookingsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { alertError, alertSuccess } = useAlertUtils();

  const getAllBookings = async () => {
    try {
      const data = await fetchData(`api/booking/get-all-bookings`);
      const sortedData = data.allBookings.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setBookingsData(sortedData);
      setLoading(false);
    } catch (error) {
      alertError("Error Fetching Booking Data");
    }
  };

  useEffect(() => {
    setLoading(true);
    getAllBookings();
  }, []);

  const handleOnChange = async (event, id) => {
    try {
      setLoading(true);
      const data = await axiosInstance.put(
        `api/booking/update-booking-status/${id}/${event}`
      );
      if (data.data.success === true) {
        alertSuccess("Status Updated Successfully");
        getAllBookings();
      } else {
        alertError("Error Updating Status");
      }
    } catch (error) {
      alertError("Error Updating Status -> ", error);
    }
  };

  return (
    <>
      <Layout>
        <div className="main_content">
          <div className="container">
            <div className="main_block">
              <div className="top_bar">
                <div className="left_part">
                  <div className="main_title">Scheduled Meetings</div>
                </div>
              </div>
              <div className="table_wrapper dashboard">
                <div className="table_inner">
                  <TableContainer component={Paper}>
                    {loading ? (
                      <div className="loader_outer">
                        <div className="loader_inner"></div>
                      </div>
                    ) : (
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="right">First Name</TableCell>
                            <TableCell align="right">Last Name</TableCell>
                            <TableCell align="right">Email</TableCell>
                            <TableCell align="right">Meeting Date</TableCell>
                            <TableCell align="right">Meeting Time</TableCell>
                            <TableCell align="right">Status</TableCell>
                            {/* <TableCell align="right">Meeting Link</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {bookingsData &&
                            bookingsData.map((row) => (
                              <TableRow
                                key={row?.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="right">
                                  <span className="mob_head">First Name</span>
                                  {row?.user?.firstName}
                                </TableCell>
                                <TableCell align="right">
                                  <span className="mob_head">Last Name</span>
                                  {row?.user?.lastName}
                                </TableCell>

                                <TableCell align="right">
                                  <span className="mob_head">Email</span>
                                  {row?.attendeeEmail}
                                </TableCell>

                                <TableCell align="right">
                                  <span className="mob_head">Meeting Date</span>
                                  {new Date(
                                    row?.meetingStartSlot
                                  ).toLocaleDateString("en-US", {
                                    weekday: "long",
                                    month: "long",
                                    day: "numeric",
                                  })}
                                </TableCell>

                                <TableCell align="right">
                                  <span className="mob_head">Meeting Time</span>
                                  {new Date(
                                    row?.meetingStartSlot
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </TableCell>

                                <TableCell align="right">
                                  <span className="mob_head">Status</span>
                                  <select
                                    value={row?.Status}
                                    onChange={(e) =>
                                      handleOnChange(e.target.value, row.id)
                                    }
                                    style={{
                                      display: "inline-block",
                                      padding: "5px 5px",
                                      borderRadius: "5px",
                                      backgroundColor:
                                        row?.Status === "Pending"
                                          ? "#fc7f03"
                                          : row?.Status === "Done"
                                          ? "green"
                                          : row?.Status === "Expired"
                                          ? "red"
                                          : null,
                                      color: "white",
                                    }}
                                  >
                                    <option
                                      style={{
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                      value="Pending"
                                    >
                                      Pending
                                    </option>
                                    <option
                                      style={{
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                      value="Done"
                                    >
                                      Done
                                    </option>
                                    <option
                                      style={{
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                      value="Expired"
                                    >
                                      Expired
                                    </option>
                                  </select>
                                </TableCell>

                                {/* <TableCell align="right">
                                <span className="mob_head">Action</span>
                                <button>
                                  <a target="_blank" href={row?.meetingLink}>
                                    Meeting Link
                                  </a>
                                </button>
                              </TableCell> */}
                              </TableRow>
                            ))}

                          {bookingsData && bookingsData.length === 0 ? (
                            <TableRow
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell colSpan={7}>
                                <div className="notice">
                                  <div className="alert">
                                    <span className="alertText">
                                      No Records Found button
                                    </span>
                                  </div>
                                </div>
                              </TableCell>
                            </TableRow>
                          ) : null}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default ScheduledMeetings;
